function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 12,
  rx: 1
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 5,
  width: 3,
  height: 12,
  rx: 1
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  width: 3,
  height: 12,
  rx: 1
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 15,
  width: 3,
  height: 12,
  rx: 1
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  width: 3,
  height: 12,
  rx: 1
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 25,
  width: 3,
  height: 12,
  rx: 1
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  width: 3,
  height: 12,
  rx: 1
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 35,
  width: 3,
  height: 12,
  rx: 1
});

var SvgMeter = function SvgMeter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 38 12",
    fill: "#5E6D7A"
  }), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

export default SvgMeter;